import type { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { useLettersCount } from '@shared/hooks';
import { cn } from '@shared/utils';
import { Footer, Header } from '@widgets';

const HEADER_ROUTES = ['/profile', '/form', '/contact'];

interface PageLayout {
  className?: string;
  children?: ReactNode;
}

export const PageLayout = (props: PageLayout) => {
  const location = useLocation();

  useLettersCount();

  return (
    <div className={cn('flex min-h-screen flex-col bg-[#fafafa]', props.className)}>
      <Header isWhite={!HEADER_ROUTES.includes(location.pathname.toLowerCase())} />
      <main className={cn('relative grow', !HEADER_ROUTES.includes(location.pathname.toLowerCase()) && 'max-md:pt-12.5')}>{props.children}</main>
      <Footer />
    </div>
  );
};
